import { z } from 'zod';

export const ResetPasswordValidator = z
  .object({
    password: z.string().min(1, {
      message: 'Please enter password.',
    }),
    confirmPassword: z.string().min(1, {
      message: 'Please enter confirm password.',
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords does not match',
  });

export type ResetPasswordFormData = z.infer<typeof ResetPasswordValidator>;
